import { LuX } from 'react-icons/lu'
import { useAffordability } from '../context/AffordabilityContext.jsx'
import { formatCurrency } from '../utils/formatters.js'

const AffordabilitySidebar = () => {
  const { profile, updateProfile, isOpen, closeSidebar, totalIncome, annualRate } = useAffordability()

  const maxBorrowable = totalIncome * 4.5
  const maxAffordable = maxBorrowable + (Number(profile.depositAmount) || 0)

  return (
    <>
      {isOpen && <div className="affordability-overlay" onClick={closeSidebar} aria-hidden="true" />}
      <aside className={`affordability-sidebar${isOpen ? ' is-open' : ''}`} aria-label="Affordability calculator" aria-hidden={!isOpen}>
        <div className="affordability-sidebar__header">
          <h2 className="affordability-sidebar__title">Affordability</h2>
          <button type="button" className="affordability-sidebar__close" onClick={closeSidebar} aria-label="Close affordability calculator">
            <LuX aria-hidden="true" />
          </button>
        </div>

        <div className="affordability-sidebar__body">
          <label className="affordability-sidebar__label">
            <span>Your annual income</span>
            <div className="affordability-sidebar__input-wrap">
              <span className="affordability-sidebar__prefix">£</span>
              <input
                type="number"
                min={0}
                step={1000}
                placeholder="e.g. 45,000"
                value={profile.income}
                onChange={(e) => updateProfile({ income: e.target.value })}
              />
            </div>
          </label>

          <label className="affordability-sidebar__checkbox-label">
            <input
              type="checkbox"
              checked={profile.isJoint}
              onChange={(e) => updateProfile({ isJoint: e.target.checked })}
            />
            Joint application
          </label>

          {profile.isJoint && (
            <label className="affordability-sidebar__label">
              <span>Partner&apos;s annual income</span>
              <div className="affordability-sidebar__input-wrap">
                <span className="affordability-sidebar__prefix">£</span>
                <input
                  type="number"
                  min={0}
                  step={1000}
                  placeholder="e.g. 35,000"
                  value={profile.partnerIncome}
                  onChange={(e) => updateProfile({ partnerIncome: e.target.value })}
                />
              </div>
            </label>
          )}

          <label className="affordability-sidebar__label">
            <span>Deposit available</span>
            <div className="affordability-sidebar__input-wrap">
              <span className="affordability-sidebar__prefix">£</span>
              <input
                type="number"
                min={0}
                step={5000}
                placeholder="e.g. 50,000"
                value={profile.depositAmount}
                onChange={(e) => updateProfile({ depositAmount: e.target.value })}
              />
            </div>
          </label>

          <label className="affordability-sidebar__label">
            <span>Mortgage term</span>
            <select value={profile.termYears} onChange={(e) => updateProfile({ termYears: Number(e.target.value) })}>
              {[15, 20, 25, 30, 35].map((y) => (
                <option key={y} value={y}>{y} years</option>
              ))}
            </select>
          </label>

          <label className="affordability-sidebar__label">
            <span>Buyer type</span>
            <select value={profile.buyerType} onChange={(e) => updateProfile({ buyerType: e.target.value })}>
              <option value="standard">Standard residential</option>
              <option value="ftb">First-time buyer</option>
              <option value="additional">Additional property</option>
            </select>
          </label>

          {totalIncome > 0 && (
            <div className="affordability-sidebar__summary">
              <div className="affordability-sidebar__summary-row">
                <span>Max borrowing (4.5× income)</span>
                <strong>{formatCurrency(maxBorrowable)}</strong>
              </div>
              {Number(profile.depositAmount) > 0 && (
                <div className="affordability-sidebar__summary-row">
                  <span>Max property price</span>
                  <strong>{formatCurrency(maxAffordable)}</strong>
                </div>
              )}
              <p className="affordability-sidebar__disclaimer">
                Indicative only. Based on {(annualRate * 100).toFixed(1)}% interest rate — actual rates vary by lender.
                Stamp duty calculated for England/NI (SDLT), Scotland (LBTT), or Wales (LTT) based on postcode.
              </p>
            </div>
          )}

          {!totalIncome && (
            <p className="affordability-sidebar__empty">
              Enter your income above to see affordability badges on listing cards.
            </p>
          )}
        </div>
      </aside>
    </>
  )
}

export default AffordabilitySidebar
